import { fetchRequestBff } from '@eventbrite/http';

export class BffRequestHandler {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    async request<T = any>(
        url: string,
        options: Partial<Request> = {},
    ): Promise<T> {
        // Construct the full path - fetchRequestBff will handle prepending
        // the BFF base URL in development if BFF_API_URL is set
        const fullPath = `${this.baseUrl}${url}`;
        try {
            const response = await fetchRequestBff(
                fullPath,
                options as RequestInit,
            );
            return (await response.json()) as T;
        } catch (error) {
            throw error;
        }
    }
}
